import { render } from "./Capital.vue?vue&type=template&id=62ff5bc4"
import script from "./Capital.vue?vue&type=script&lang=js"
export * from "./Capital.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/buildings/residence/Capital.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "62ff5bc4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('62ff5bc4', __exports__)) {
    api.reload('62ff5bc4', __exports__)
  }
  
  module.hot.accept("./Capital.vue?vue&type=template&id=62ff5bc4", () => {
    api.rerender('62ff5bc4', render)
  })

}


export default __exports__